import axiosInstance from "../../api/axiosInstance";

export const fetchReportedCommentsAPI = async ({
  status = "open",
  tournamentId,
  page = 1,
  limit = 20,
}) => {
  const params = new URLSearchParams({
    status,
    page: page.toString(),
    limit: limit.toString(),
  });
  if (tournamentId) {
    params.append("tournamentId", tournamentId);
  }

  const response = await axiosInstance.get(
    `adminCommentsReports/admin/comment-reports?${params.toString()}`,
  );

  return response.data;
};

export const fetchCommentReportsAPI = async (commentId) => {
  const response = await axiosInstance.get(
    `adminCommentsReports/admin/tournament-comments/${commentId}/reports`,
  );

  return response.data;
};

export const hideCommentAPI = async (commentId, isHidden, hideReason) => {
  const response = await axiosInstance.patch(
    `adminCommentsReports/admin/tournament-comments/${commentId}/hide`,
    { isHidden, hideReason },
  );

  return response.data;
};

export const deleteCommentAPI = async (commentId) => {
  const response = await axiosInstance.delete(
    `adminCommentsReports/admin/tournament-comments/${commentId}`,
  );

  return response.data;
};

export const dismissReportsAPI = async (commentId, adminNote) => {
  const response = await axiosInstance.patch(
    `adminCommentsReports/admin/tournament-comments/${commentId}/dismiss-reports`,
    { adminNote },
  );

  return response.data;
};

export const fetchPreviousReportsAPI = async ({
  status,
  tournamentId,
  actionTaken,
  page = 1,
  limit = 20,
}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  if (status) {
    params.append("status", status);
  }
  if (tournamentId) {
    params.append("tournamentId", tournamentId);
  }
  if (actionTaken) {
    params.append("actionTaken", actionTaken);
  }

  const response = await axiosInstance.get(
    `adminCommentsReports/admin/previous-reports?${params.toString()}`,
  );

  return response.data;
};

export const restoreDeletedCommentAPI = async (commentId) => {
  const response = await axiosInstance.patch(
    `adminCommentsReports/admin/tournament-comments/${commentId}/restore`,
  );

  return response.data;
};
